import script from "./RecommendList.vue?vue&type=script&setup=true&lang=js"
export * from "./RecommendList.vue?vue&type=script&setup=true&lang=js"

import "./RecommendList.vue?vue&type=style&index=0&id=510b61dd&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-510b61dd"]])

export default __exports__